import { render, staticRenderFns } from "./TranslationsEdit.vue?vue&type=template&id=32daa9e1"
import script from "./TranslationsEdit.vue?vue&type=script&lang=js"
export * from "./TranslationsEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports